var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9838 7.54889H11.3148L15.3584 5.2143L14.4704 3.67579L10.4268 6.01037L12.7609 1.96707L11.2223 1.07854L8.88826 5.12183V0.453125H7.11216V5.12228L4.77721 1.07854L3.23918 1.96662L5.57369 6.00992L1.53006 3.67579L0.641998 5.21386L4.68563 7.54844H0.0166016V9.32462H4.68518L0.641998 11.6592L1.53006 13.1977L5.57324 10.8636L3.23873 14.9069L4.77721 15.7949L7.11172 11.7512V16.4204H8.88784V11.7517L11.2219 15.7949L12.7603 14.9069L10.4259 10.8631L14.4695 13.1977L15.3576 11.6592L11.3144 9.32504H15.9829V7.54889H15.9838ZM8.00022 10.8524C6.66099 10.8524 5.57547 9.76689 5.57547 8.42759C5.57547 7.08832 6.66099 6.00278 8.00022 6.00278C9.33946 6.00278 10.4249 7.08832 10.4249 8.42759C10.4249 9.76689 9.33946 10.8524 8.00022 10.8524Z",
    fill: "#625DF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoomIcon);
export default __webpack_public_path__ + "static/media/loom_icon.cf194dd1.svg";
export { ForwardRef as ReactComponent };